export default __webpack_public_path__ + "static/media/vendor.963cd072.png";